import React from 'react';

/** Plugins */
import { useDispatch } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, Button } from '@material-ui/core';

/** Helpers */
import { showAlert } from '../../store/ducks/alert';

/** Services */
import { deleteTag } from '../../services/tags';

const DeleteTag = ({ onClose, tagId, slug }) => {
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    try {
      await deleteTag(tagId);
      dispatch(showAlert('success', 'Tag Deleted!'));
      window.location = '/tags';
    } catch (ex) {
      dispatch(showAlert('error', 'Error! We could not delete this tag. 😔'));
    }
  };

  return (
    <div className="delete-container">
      <div className="delete-container-top">
        <h2>Are you sure you want to delete this tag? The relations with the Issues will be deleted too</h2>

        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <div>
        <h3>Tag Slug: {slug}</h3>
      </div>
      <Button onClick={handleSubmit} variant="contained" className="modal-btn">
        Yes
      </Button>
    </div>
  );
};
export default DeleteTag;
